export const formatDate = (value) => {
    if (!value) {
        return "-";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return String(value);
    }

    return date.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

const parseTournamentDate = (value) => {
    if (!value) {
        return null;
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const isTournamentFinished = (tournament) => {
    if (!tournament) {
        return false;
    }

    if (tournament.winnerTeamId != null || Boolean(tournament.winnerTeamName)) {
        return true;
    }

    if (!tournament.started || !tournament.endDate) {
        return false;
    }

    const endDate = parseTournamentDate(tournament.endDate);
    if (!endDate) {
        return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate < today;
};

export const sortTournamentsForOverview = (tournaments) => {
    if (!Array.isArray(tournaments)) {
        return [];
    }

    return [...tournaments].sort((leftTournament, rightTournament) => {
        const leftFinished = isTournamentFinished(leftTournament);
        const rightFinished = isTournamentFinished(rightTournament);

        if (leftFinished !== rightFinished) {
            return leftFinished ? 1 : -1;
        }

        return 0;
    });
};

export const getTournamentPhaseLabel = (tournament) => {
    if (!tournament) {
        return "Unbekannt";
    }
    if (tournament.groupPhaseClosed) {
        return "K.O.-Phase";
    }
    if (tournament.started) {
        return "Gruppenphase";
    }
    if (tournament.registrationOpen) {
        return "Anmeldung geöffnet";
    }
    return "Anmeldung geschlossen";
};

export const getMatchTeamId = (match, key) => match?.[key]?.id ?? match?.[`${key}Id`] ?? null;

export const findMatchForTeams = (matches, id1, id2) =>
    matches.find(
        (match) =>
            (getMatchTeamId(match, "team1") === id1 && getMatchTeamId(match, "team2") === id2)
            || (getMatchTeamId(match, "team1") === id2 && getMatchTeamId(match, "team2") === id1)
    );

export const getParticipantName = (participantOrId, groupPlayers, tournamentPlayers) => {
    const participant = typeof participantOrId === "object" && participantOrId !== null
        ? participantOrId
        : groupPlayers.find((player) => player.id === participantOrId)
        || tournamentPlayers.find((player) => player.id === participantOrId);

    if (!participant) {
        return typeof participantOrId === "number" ? `Team #${participantOrId}` : String(participantOrId ?? "?");
    }
    if (participant.displayName) {
        return participant.displayName;
    }
    if (participant.name) {
        return participant.name;
    }
    if (Array.isArray(participant.players) && participant.players.length > 0) {
        return participant.players.map((player) => player.name).join(" / ");
    }
    return `Team #${participant.id}`;
};

